import { HTTP_STATUS_CODE, IHttpGet } from '../../adapters';
import { ISheetFundWalletResponse } from './dto';

export class SheetFundWalletUseCase {
  constructor(
    private readonly url: string,
    private readonly http: IHttpGet<ISheetFundWalletResponse>
  ) {}

  async execute(fundSlug: string, fundStatus: string) {
    if (fundStatus === 'pre-operacional') return;

    const { statusCode, body } = await this.http.get({
      url: `${this.url}/${fundSlug}`,
    });

    switch (statusCode) {
      case HTTP_STATUS_CODE.ok:
        return body;

      default:
        return null;
    }
  }
}
